export const languages = [
  { code: 'EN', label: 'English' },
  { code: 'JP', label: 'Japanese' },
  { code: 'ID', label: 'Indonesian' }
];

export type TranslationKey = 
  | 'about' 
  | 'home'
  | 'resume' 
  | 'portfolio' 
  | 'blog' 
  | 'psychometric' 
  | 'getInTouch' 
  | 'introTitle' 
  | 'introSub' 
  | 'learnMore' 
  | 'myResume' 
  | 'tiktok' 
  | 'tiktokTitle' 
  | 'techStack' 
  | 'workTogether' 
  | 'getInTouchNow' 
  | 'growth' 
  | 'pokemonTitle' 
  | 'privacy' 
  | 'terms'
  | 'privacyIntroTitle'
  | 'privacyIntroContent'
  | 'privacyCollectionTitle'
  | 'privacyCollectionContent'
  | 'privacyUseTitle'
  | 'privacyUseContent'
  | 'privacyCookiesTitle'
  | 'privacyCookiesContent'
  | 'privacyContactTitle'
  | 'privacyContactContent'
  | 'termsAgreementTitle'
  | 'termsAgreementContent'
  | 'termsIPTitle'
  | 'termsIPContent'
  | 'termsUseTitle'
  | 'termsUseContent'
  | 'termsDisclaimersTitle'
  | 'termsDisclaimersContent'
  | 'termsChangesTitle'
  | 'termsChangesContent'
  | 'termsContactTitle'
  | 'termsContactContent'
  | 'lastUpdated'
  | 'aboutMeTitle'
  | 'heyFaizi'
  | 'aboutMeContent'
  | 'experienceTitle'
  | 'seeSkillset'
  | 'seeResume'
  | 'psychometricTitle'
  | 'growthMarketer'
  | 'chatPrompt'
  | 'assessmentOverview'
  | 'thinking'
  | 'connecting'
  | 'executing'
  | 'progressing'
  | 'roleFit' 
  | 'organisationFit' 
  | 'aboutSnapsych'
  | 'analysing'
  | 'exploring'
  | 'networking'
  | 'collaborating'
  | 'quality'
  | 'resultsDriven'
  | 'leadership'
  | 'resilience'
  | 'adaptability'
  | 'thinkingContent1'
  | 'thinkingContent2'
  | 'connectingContent1'
  | 'connectingContent2'
  | 'executingContent1'
  | 'executingContent2'
  | 'progressingContent1'
  | 'progressingContent2'
  | 'progressingContent3'
  | 'roleFit1'
  | 'roleFit2'
  | 'roleFit3'
  | 'orgFit1'
  | 'orgFit2'
  | 'snapsychContent1'
  | 'snapsychContent2'
  | 'snapsychContent3'
  | 'workMagicRole'
  | 'tiktokRole'
  | 'greenhouseRole'
  | 'present'
  | 'skillsetTitle'
  | 'growthStrategy'
  | 'marketingChannels'
  | 'productAnalytics'
  | 'toolsTech'
  | 'growthHacking'
  | 'cro'
  | 'abTesting'
  | 'userAcquisition'
  | 'performanceMarketing'
  | 'seo'
  | 'socialMedia'
  | 'aso'
  | 'productManagement'
  | 'dataAnalytics'
  | 'martech'
  | 'businessIntelligence'
  | 'jun2023'
  | 'apr2021'
  | 'jun2019'
  | 'achiever'
  | 'analytical'
  | 'tenacious'
  | 'resumeSubtitle'
  | 'workExperience'
  | 'education'
  | 'theChallenge'
  | 'solutions'
  | 'keyResults'
  | 'aboutClient'
  | 'readyToAchieve'
  | 'backToPortfolio'
  | 'projectNotFound'
  | 'scrollZoomHint'
  | 'client'
  | 'categoryLabel'
  | 'locationKL'
  | 'workMagicDesc'
  | 'tiktokDesc'
  | 'greenhouseDesc'
  | 'degreeTitle'
  | 'uniName'
  | 'degreeDesc'
  | 'graduated2016'
  | 'selectedWorks'
  | 'portfolioSubtitle'
  | 'basedIn'
  | 'viewCaseStudy'
  | 'haveProject'
  | 'projectDesc'
  | 'letsTalk'
  | 'blogSubtitle'
  | 'stayInLoop'
  | 'newsletterDesc'
  | 'subscribe'
  | 'emailPlaceholder'
  | 'readMore'
  | 'letsConnect'
  | 'contactSubtitle'
  | 'contactDescription'
  | 'wantToCallMe'
  | 'scheduleCall'
  | 'wantToEmailMe'
  | 'emailMe'
  | 'socialHandle'
  | 'location'
  | 'followMe'
  | 'fullName'
  | 'email'
  | 'subject'
  | 'subjectPlaceholder'
  | 'message'
  | 'emailAddress'
  | 'yourMessage'
  | 'messagePlaceholder'
  | 'sendMessage'
  | 'sending'
  | 'messageSent'
  | 'messageSuccess'
  | 'messageError'
  | 'sendAnother'
  | 'captchaRequired'
  | 'licensesAndCertifications'
  | 'skills'
  | 'irepRole'
  | 'irepDesc'
  | 'locationTokyo'
  | 'locationBandung'
  | 'locationJakarta'
  | 'locationUSRemote'
  | 'locationSGRemote'
  | 'oct2018'
  | 'may2019'
  | 'sep2016'
  | 'mar2018'
  | 'aug2018'
  | 'jan2016'
  | 'may2020'
  | 'may2021'
  | 'jun2022'
  | 'dec2017'
  | 'dec2018'
  | 'feb2019'
  | 'feb2020'
  | 'mar2019'
  | 'mar2020'
  | 'license1Title'
  | 'license1Issuer'
  | 'license2Title'
  | 'license2Issuer'
  | 'license3Title'
  | 'license3Issuer'
  | 'license4Title'
  | 'license4Issuer'
  | 'license5Title'
  | 'license5Issuer'
  | 'license6Title'
  | 'license6Issuer'
  | 'license7Title'
  | 'license7Issuer'
  | 'credentialId'
  | 'expires'
  | 'skillCategory1'
  | 'skillCategory2'
  | 'skillCategory3'
  | 'skillCategory4'
  | 'portfolioProject1Title'
  | 'portfolioProject1Desc'
  | 'portfolioProject2Title'
  | 'portfolioProject2Desc'
  | 'portfolioProject3Title'
  | 'portfolioProject3Desc'
  | 'portfolioProject4Title'
  | 'portfolioProject4Desc'
  | 'nov2017'
  | 'pageNotFound'
  | 'backToHome'
  | 'oops'
  | 'pricing'
  | 'pricingTitle'
  | 'pricingSubtitle'
  | 'category'
  | 'items'
  | 'adSpendLimits'
  | 'adSpendingRange'
  | 'monthlyFee'
  | 'threeMonthCommitment'
  | 'sixMonthCommitment'
  | 'annualCommitment'
  | 'monthlyCommitment'
  | 'noCommitment'
  | 'noDiscount'
  | 'monthlyAdSpend'
  | 'calculatePlan'
  | 'sliderHint'
  | 'estimatedManagementFee'
  | 'selectedPlan'
  | 'yourMonthlySpend'
  | 'retainerLimits'
  | 'consultant'
  | 'adOpsSpecialists'
  | 'serviceDetails'
  | 'meetingCadence'
  | 'reportingPlatform'
  | 'adChannels'
  | 'upgrades'
  | 'crmIntegration'
  | 'creativesProduction'
  | 'pricingNote'
  | 'choosePlan'
  | 'customQuote'
  | 'flat'
  | 'discount'
  | 'standard'
  | 'standardTier'
  | 'growthTier'
  | 'scaleTier'
  | 'premiumTier'
  | 'enterpriseTier';

export const translations: Record<string, Record<TranslationKey, string>> = {
  EN: {
    about: "About",
    home: "Home",
    resume: "Resume",
    portfolio: "Portfolio",
    blog: "Blog",
    psychometric: "Psychometric",
    getInTouch: "Get in Touch",
    introTitle: "Hey, I'm Faizi!",
    introSub: "Growth Marketing & Product Lead at WorkMagic",
    learnMore: "Learn more about me",
    myResume: "My resume",
    tiktok: "TikTok",
    tiktokTitle: "Conversion Lift Study",
    workTogether: "Let's work together ✨",
    getInTouchNow: "Get in touch now",
    growth: "Growth",
    pokemonTitle: "Inside Pokémon's Monetization Engine Strategy",
    privacy: "Privacy Policy",
    terms: "Terms",
    privacyIntroTitle: "Introduction",
    privacyIntroContent: "Your privacy is important to me. This Privacy Policy explains how I collect, use, and protect your information when you visit my website.",
    privacyCollectionTitle: "Information Collection",
    privacyCollectionContent: "I do not collect any personally identifiable information (PII) unless you voluntarily provide it through the contact form or newsletter subscription. This may include your name and email address.",
    privacyUseTitle: "Use of Information",
    privacyUseContent: "Any information provided is used solely to respond to your inquiries or send you requested updates. I do not sell or share your information with third parties for marketing purposes.",
    privacyCookiesTitle: "Cookies",
    privacyCookiesContent: "This website may use basic cookies to enhance your browsing experience and analyze site traffic. You can choose to disable cookies through your browser settings.",
    privacyContactTitle: "Contact",
    privacyContactContent: "If you have any questions regarding this Privacy Policy, please contact me at:",
    termsAgreementTitle: "Agreement to Terms",
    termsAgreementContent: "By accessing and using this website, you agree to be bound by these Terms of Service. If you do not agree, please do not use the site.",
    termsIPTitle: "Intellectual Property",
    termsIPContent: "All content on this website, including text, images, and code, is the property of Faizi Zahari unless otherwise noted. You may not reproduce or distribute any content without prior written permission.",
    termsUseTitle: "Use of Website",
    termsUseContent: "You agree to use this website for lawful purposes only. You are prohibited from attempting to gain unauthorized access to any portion of the site or its systems.",
    termsDisclaimersTitle: "Disclaimers",
    termsDisclaimersContent: "The information on this website is provided \"as is\" without warranties of any kind. I am not liable for any damages arising from your use of the site or its content.",
    termsChangesTitle: "Changes to Terms",
    termsChangesContent: "I reserve the right to modify these Terms of Service at any time. Your continued use of the website after any changes indicates your acceptance of the new terms.",
    termsContactTitle: "Contact",
    termsContactContent: "If you have any questions regarding these Terms of Service, please contact me at:",
    lastUpdated: "Last updated",
    aboutMeTitle: "About Me",
    heyFaizi: "Hey, I'm Faizi",
    aboutMeContent: "I am a data-driven digital marketer with experience handling digital campaign from various verticals such as OTA, E-commerce, Banking, B2B SaaS, Office Space, Logistic, and many SMBs.",
    experienceTitle: "Experience",
    seeSkillset: "See my skillset",
    seeResume: "See my resume",
    psychometricTitle: "Psychometric",
    growthMarketer: "Growth Marketer",
    chatPrompt: "Let's have a chat",
    assessmentOverview: "Assessment overview",
    thinking: "Thinking",
    connecting: "Connecting",
    executing: "Executing",
    progressing: "Progressing",
    roleFit: "Role Fit",
    organisationFit: "Organisation fit",
    aboutSnapsych: "About Snapsych Assessment",
    analysing: "Analysing",
    exploring: "Exploring",
    networking: "Networking",
    collaborating: "Collaborating",
    quality: "Quality",
    resultsDriven: "Results Driven",
    leadership: "Leadership",
    resilience: "Resilience",
    adaptability: "Adaptability",
    thinkingContent1: "Faizi is comfortable in dealing with numerical data to understand problems and solve them. Faizi tends to be factual and uses evidence to support their hypothesis.",
    thinkingContent2: "Faizi is curious and likes to explore new ideas and approaches. When faced with a problem, Faizi tends to think out of the box and enjoys considering a wide range of alternatives. Faizi looks for opportunities to learn and thrive in roles which offer them novelty and variety. On the flip side, Faizi may get bored in routines and at times may be perceived as overly optimistic or having impractical ideas.",
    connectingContent1: "Faizi is someone who feels at ease when connecting with new people and generally has a well-developed network.",
    connectingContent2: "Faizi tends to keep their opinions to themselves and avoids getting involved in problems of their co-workers. Faizi can be quite competitive and may be skeptical about people unless proven otherwise. Faizi may take decisions without considering the viewpoints of others.",
    executingContent1: "Faizi tends to be systematic, methodical and organised and delivers within deadlines. Faizi is reliable and disciplined and driven to achieve their goals.",
    executingContent2: "Faizi pays attention to details and enjoys delivering work that is of a high standard.",
    progressingContent1: "Faizi recovers quickly from setbacks and does not let negativity pull them down. Faizi views failures as learning opportunities and an intrinsic part of the route to success.",
    progressingContent2: "Faizi is focused and drives their team towards desired outcomes irrespective of obstacles.",
    progressingContent3: "Faizi prefers to work in stable environments and is uncomfortable with dealing with unplanned changes.",
    roleFit1: "Roles with clear goals or timelines, where performance can be easily measured.",
    roleFit2: "Roles which relate to research, analysis, data analytics or applying rational thinking to solve problems.",
    roleFit3: "Roles dealing with implementing new practices, conflict management.",
    orgFit1: "Organisations that are fast paced, results oriented and offer clear career paths linked to your performance.",
    orgFit2: "Organisations that promote evidence based critical thinking.",
    snapsychContent1: "Snapsych is based on the Big Five and related frameworks which are used by firms globally. It has been measured against two widely used Big Five personality tests and shown good correlation (Saucier's mini-markers and Big Five Inventory).",
    snapsychContent2: "Accuracy (reliability) of the test Average alpha is .88, which is considered as very good as compared to an industry benchmark (> .70).",
    snapsychContent3: "Validity The test provides good face validity with questions based on modern occupational settings. The test also has a good Construct Validity and the structure of the Big Five as well as the correlation between Big Five factors and Snapsych have been statistically tested at threshold p <.05 and p<.01.",
    workMagicRole: "Growth Marketing & Product Lead",
    tiktokRole: "Growth Marketing Manager",
    greenhouseRole: "Growth Marketer",
    present: "Present",
    skillsetTitle: "Skillset",
    growthStrategy: "Growth & Strategy",
    marketingChannels: "Marketing Channels",
    productAnalytics: "Product & Analytics",
    toolsTech: "Tools & Technologies",
    growthHacking: "Growth Hacking",
    cro: "Conversion Rate Optimization (CRO)",
    abTesting: "A/B Testing & Experimentation",
    userAcquisition: "User Acquisition Strategy",
    performanceMarketing: "Performance Marketing (TikTok, Meta, Google)",
    seo: "Search Engine Optimization (SEO)",
    socialMedia: "Social Media Marketing",
    aso: "App Store Optimization (ASO)",
    productManagement: "Product Management",
    dataAnalytics: "Data Analytics (SQL, Python)",
    martech: "Marketing Technology (MarTech)",
    businessIntelligence: "Business Intelligence",
    jun2023: "Jun 2023",
    apr2021: "Apr 2021",
    jun2019: "Jun 2019",
    achiever: "Achiever",
    analytical: "Analytical",
    tenacious: "Tenacious",
    resumeSubtitle: "A timeline of my professional journey and academic background.",
    workExperience: "Work Experience",
    education: "Education",
    locationKL: "Kuala Lumpur, Malaysia",
    workMagicDesc: "<strong>As a Growth Marketing Lead</strong>, I focused on driving user acquisition, retention, and monetization by launching multi-channel campaigns, optimizing onboarding funnels, and personalizing marketing using cohort and product data. This led to significant increases in trial conversions, LTV, and ROI across campaigns.<br/><br/><strong>As a Product Operations Lead</strong>, I worked cross-functionally with engineering and data teams to streamline delivery, enhance AI model performance, and build scalable processes around QA, prompt engineering, and internal documentation. These efforts directly improved product velocity, quality, and team onboarding speed.",
    tiktokDesc: "<strong>Growth Country Manager (APAC):</strong><ul class='list-disc ml-5 mt-2 mb-4 space-y-1'><li>Making sure all country achieve ROI target.</li><li>Communicate with cross functional team in the region.</li></ul><strong>Paid Ads Agency Manager (APAC, EMEA & NA):</strong><ul class='list-disc ml-5 mt-2 mb-4 space-y-1'><li>Manage Agency communication in SEA, EMEA and NA.</li><li>Monitor Spending and Performance for each country making sure achieve ROI target.</li><li>Analyze campaign performance and suggest technical recommendation to the agency.</li><li>Manage agency tasks and make sure executed as plan.</li></ul><strong>SEO Project Manager (Global):</strong><ul class='list-disc ml-5 mt-2 space-y-1'><li>Create SEO Roadmap and Plan for TT4B Official Website.</li><li>Conduct Site Audit for technical Improvement.</li><li>Create PRD for tech team to implement.</li><li>Working on On-page optimization with content team.</li></ul>",
    greenhouseDesc: "<strong>Paid Ads Specialist:</strong><ul class='list-disc ml-5 mt-2 mb-4 space-y-1'><li>Develop a robust data-driven digital marketing strategy.</li><li>Map and analyze existing digital marketing channel and create improvement strategy.</li><li>Feed the business by optimizing digital marketing campaign to achieve target Revenue & ROI.</li><li>Support the sales team by providing qualified leads from paid ads.</li></ul><strong>Tracking & Data Integration Manager:</strong><ul class='list-disc ml-5 mt-2 mb-4 space-y-1'><li>Develop and implement a world-class data tracking & tagging strategies for all digital marketing funnels.</li><li>Lead data integrations between our platform.</li><li>Automate data streamline by building workflows in CRM.</li><li>Implement analytics tracking needed for ongoing reporting and analysis activities.</li></ul><strong>Data Reporting & Visualization:</strong><ul class='list-disc ml-5 mt-2 mb-4 space-y-1'><li>Build a comprehensive digital marketing report.</li><li>Develop ops metric to track all business-related metrics.</li><li>Unifying Data Reporting across Marketing Department using an integrated data source.</li></ul><strong>SEO Manager:</strong><ul class='list-disc ml-5 mt-2 mb-4 space-y-1'><li>Developing and implementing effective SEO Plan & Strategies.</li><li>Conduct keyword research to guide content teams.</li><li>Review technical SEO issues and recommend fixes.</li><li>Optimize website content, landing pages to follow SEO aspects.</li><li>Drive entire company to perform link-building effort.</li></ul><strong>QA Product Tester:</strong><ul class='list-disc ml-5 mt-2 space-y-1'><li>Execute test cases (manual or automated) and analyze results.</li><li>Report bugs and errors to development teams.</li></ul>",
    degreeTitle: "Bachelor of Engineering, Urban Planning",
    uniName: "Bandung Institute of Technology",
    degreeDesc: "Specialized in urban spatial analysis, regional infrastructure planning, and sustainable urban development. Completed a comprehensive thesis on a comparative study of disaster resilience between Indonesia and Japan.",
    graduated2016: "Sep 2009 - Mar 2015",
    selectedWorks: "Selected Works",
    portfolioSubtitle: "A collection of projects spanning product design, growth strategy, and technical implementation. Each piece represents a unique challenge solved through data and design.",
    basedIn: "Based in",
    viewCaseStudy: "View Case Study",
    haveProject: "Have a project in mind?",
    projectDesc: "I'm always open to discussing new projects, creative ideas or opportunities to be part of your visions.",
    letsTalk: "Let's Talk",
    blogSubtitle: "Exploring the intersection of design, technology, and human behavior. Weekly insights on building and scaling digital products.",
    stayInLoop: "Stay in the loop.",
    newsletterDesc: "Subscribe to my newsletter to receive the latest articles, resources, and insights directly in your inbox.",
    subscribe: "Subscribe",
    emailPlaceholder: "Your email address",
    readMore: "Read More",
    letsConnect: "Let's Connect",
    contactSubtitle: "Have a project in mind or just want to chat about growth, product, or technology? I'm always open to new opportunities and conversations.",
    contactDescription: "I'm always open to collaborate on a project or hear about an opportunity!",
    wantToCallMe: "WANT TO CALL ME?",
    scheduleCall: "Schedule a call with me",
    wantToEmailMe: "JUST WANT TO EMAIL ME?",
    emailMe: "Email Me",
    socialHandle: "Social Handle",
    location: "Location",
    followMe: "Follow Me",
    fullName: "Full Name",
    email: "Email",
    subject: "Subject",
    subjectPlaceholder: "How can I help you?",
    message: "Message",
    emailAddress: "Email Address",
    yourMessage: "Your Message",
    messagePlaceholder: "Tell me about your project...",
    sendMessage: "Send Message",
    sending: "Sending...",
    messageSent: "Message Sent!",
    messageSuccess: "Thank you for reaching out. I'll get back to you as soon as possible.",
    messageError: "Something went wrong. Please try again or email me directly.",
    sendAnother: "Send another message",
    captchaRequired: "Please complete the captcha.",
    theChallenge: "The Challenge",
    solutions: "Solutions",
    keyResults: "Key Results",
    aboutClient: "About",
    readyToAchieve: "Ready to achieve similar results?",
    backToPortfolio: "Back to Portfolio",
    projectNotFound: "Project not found",
    scrollZoomHint: "Scroll to zoom • Drag to pan • Pinch on mobile",
    client: "Client",
    categoryLabel: "Category",
    licensesAndCertifications: "Licenses & Certifications",
    skills: "Skills",
    irepRole: "Digital Marketing Strategist & Media Planner",
    irepDesc: "<strong>Digital Marketing Strategist:</strong><ul class='list-disc ml-5 mt-2 mb-4 space-y-1'><li>Perform keyword planning and generate keyword multiplication to reach potential user acquisition.</li><li>Manage & execute campaign in paid search advertisement to meet client's KPI.</li><li>Monitoring and tracking budget pace for on-going campaign.</li><li>Doing analytics to optimize campaign performance.</li><li>Optimizing Ads copy and Landing Page by doing A/B Testing and LP Testing.</li><li>Creating campaign report and presentation.</li></ul><strong>Digital Media Planner:</strong><ul class='list-disc ml-5 mt-2 space-y-1'><li>Arrange meeting with potential client, advising and giving ideas to client for their strategic marketing plan by submitting digital marketing proposal.</li><li>Giving suggestion of each digital marketing channel based on client business goal.</li><li>Make a digital media planning, presenting, and execute the plan such as project schedule, budget planning, and quality management.</li><li>Summarizes results of ad campaign and describe it into an insightful report.</li><li>Analyze a result of ad campaign and give suggestion and improvement proposal as next action to push clients business progress ahead.</li><li>Having regular meeting with client to report campaign progress and improvement proposal.</li></ul>",
    locationTokyo: "Tokyo, Japan",
    locationBandung: "Bandung, Indonesia",
    locationJakarta: "Jakarta, Indonesia",
    locationUSRemote: "United States (Remote)",
    locationSGRemote: "Singapore (Remote)",
    oct2018: "Oct 2018",
    may2019: "May 2019",
    sep2016: "Sep 2016",
    mar2018: "Mar 2018",
    aug2018: "Aug 2018",
    jan2016: "Jan 2016",
    may2020: "May 2020",
    may2021: "May 2021",
    jun2022: "Jun 2022",
    dec2017: "Dec 2017",
    dec2018: "Dec 2018",
    feb2019: "Feb 2019",
    feb2020: "Feb 2020",
    mar2019: "Mar 2019",
    mar2020: "Mar 2020",
    license1Title: "Google Search Ads Certification",
    license1Issuer: "Google",
    license2Title: "Inbound Marketing Certification",
    license2Issuer: "HubSpot",
    license3Title: "Japanese Language Proficiency Test N3",
    license3Issuer: "The Japan Foundation",
    license4Title: "Hubspot Marketing Software Certification",
    license4Issuer: "Hubspot",
    license5Title: "Google Shopping Ads Certification",
    license5Issuer: "Google",
    license6Title: "Google Video Ads Certification",
    license6Issuer: "Google",
    license7Title: "Google Analytics Individual Qualification",
    license7Issuer: "Google",
    credentialId: "Credential ID",
    expires: "Expires",
    skillCategory1: "Growth & Strategy",
    skillCategory2: "Marketing Channels",
    skillCategory3: "Product & Analytics",
    skillCategory4: "Tools & Technologies",
    portfolioProject1Title: "Conversion Lift Study to see ROI lift by running Upper Funnel Campaign",
    portfolioProject1Desc: "Analyzing the impact of upper funnel campaigns on overall ROI through comprehensive conversion lift studies.",
    portfolioProject2Title: "How CoHive Decrease CPA by 62% using Conversion Rate Optimization Strategy",
    portfolioProject2Desc: "Implementing a strategic CRO framework to significantly reduce acquisition costs and improve user journey efficiency.",
    portfolioProject3Title: "How DJT increased their avg monthly organic traffic by 40x in 6 Months",
    portfolioProject3Desc: "Driving explosive organic growth through technical SEO audits and content strategy optimization.",
    portfolioProject4Title: "How Lemonilo increased the ROAS by 8x using Shopping Ads",
    portfolioProject4Desc: "Optimizing shopping ad campaigns to maximize return on ad spend for a leading health-focused e-commerce brand.",
    nov2017: "Nov 2017",
    techStack: "Tech Stack",
    pageNotFound: "Page Not Found",
    backToHome: "Back to Home",
    oops: "Oops! The page you're looking for doesn't exist.",
    pricing: "Pricing",
    pricingTitle: "Growth Marketing & Ad Ops Pricing",
    pricingSubtitle: "Transparent, performance-driven retainer plans designed to scale your business with full-funnel ad operations and growth strategy.",
    category: "Category",
    items: "Items",
    adSpendLimits: "Ad Spend Limits",
    adSpendingRange: "Ad Spending Range",
    monthlyFee: "Monthly Fee",
    threeMonthCommitment: "3 Month Commitment",
    sixMonthCommitment: "6 Months Commitment",
    annualCommitment: "Annual Commitment",
    monthlyCommitment: "Monthly",
    noCommitment: "No Commitment",
    noDiscount: "No Discount",
    monthlyAdSpend: "Monthly Ad Spend",
    calculatePlan: "Find Your Plan & Calculate Fee",
    sliderHint: "Drag slider or type your monthly ad budget to calculate the exact management fee and match your tier.",
    estimatedManagementFee: "Estimated Management Fee",
    selectedPlan: "Matched Tier",
    yourMonthlySpend: "Monthly Ad Budget",
    retainerLimits: "Retainer Limits",
    consultant: "Consultant",
    adOpsSpecialists: "Ad Ops (Specialists)",
    serviceDetails: "Service Details",
    meetingCadence: "Meeting Cadence",
    reportingPlatform: "Reporting Platform",
    adChannels: "Ad Channels",
    upgrades: "Upgrades",
    crmIntegration: "CRM Integration",
    creativesProduction: "Creatives Production",
    pricingNote: "Note: All plans inherently include Project Planning, Campaign Planning, Ads Setup, Ads Optimization, Tracking Setup, and Reporting.",
    choosePlan: "Select Plan",
    customQuote: "Custom Quote",
    flat: "Flat",
    discount: "Discount",
    standard: "Standard",
    standardTier: "Standard",
    growthTier: "Growth",
    scaleTier: "Scale",
    premiumTier: "Premium",
    enterpriseTier: "Enterprise",
  },
  JP: {
    about: "概要",
    home: "ホーム",
    resume: "履歴書",
    portfolio: "ポートフォリオ",
    blog: "ブログ",
    psychometric: "適性検査",
    getInTouch: "お問い合わせ",
    introTitle: "こんにちは、Faiziです！",
    introSub: "WorkMagicのグロースマーケティング＆プロダクトリード",
    learnMore: "私についてもっと知る",
    myResume: "私の履歴書",
    tiktok: "TikTok",
    tiktokTitle: "コンバージョンリフト調査",
    workTogether: "一緒に働きましょう ✨",
    getInTouchNow: "今すぐ連絡する",
    growth: "グロース",
    pokemonTitle: "ポケモンの収益化エンジン戦略の内部",
    privacy: "プライバシーポリシー",
    terms: "利用規約",
    privacyIntroTitle: "はじめに",
    privacyIntroContent: "あなたのプライバシーは私にとって重要です。このプライバシーポリシーは、あなたが私のウェブサイトを訪問した際に、私がどのようにあなたの情報を収集、使用、保護するかを説明するものです。",
    privacyCollectionTitle: "情報の収集",
    privacyCollectionContent: "お問い合わせフォームやニュースレターの購読を通じて自発的に提供されない限り、個人を特定できる情報（PII）を収集することはありません。これには、お名前やメールアドレスが含まれる場合があります。",
    privacyUseTitle: "情報の利用",
    privacyUseContent: "提供された情報は、お問い合わせへの回答や、リクエストされたアップデートの送信のみに使用されます。マーケティング目的で第三者に情報を販売したり共有したりすることはありません。",
    privacyCookiesTitle: "クッキー（Cookies）",
    privacyCookiesContent: "このウェブサイトでは、閲覧体験の向上やサイトトラフィックの分析のために、基本的なクッキーを使用する場合があります。ブラウザの設定でクッキーを無効にすることを選択できます。",
    privacyContactTitle: "お問い合わせ",
    privacyContactContent: "このプライバシーポリシーに関するご質問がある場合は、以下までご連絡ください。",
    termsAgreementTitle: "規約への同意",
    termsAgreementContent: "このウェブサイトにアクセスして利用することにより、これらの利用規約に拘束されることに同意したものとみなされます。同意しない場合は、サイトを利用しないでください。",
    termsIPTitle: "知的財産権",
    termsIPContent: "このウェブサイト上のすべてのコンテンツ（テキスト、画像、コードを含む）は、特に明記されていない限り、Faizi Zahariの所有物です。事前の書面による許可なく、コンテンツを複製または配布することはできません。",
    termsUseTitle: "ウェブサイトの利用",
    termsUseContent: "あなたはこのウェブサイトを合法的な目的のみに使用することに同意します。サイトのいかなる部分やシステムに対しても、不正アクセスを試みることは禁止されています。",
    termsDisclaimersTitle: "免責事項",
    termsDisclaimersContent: "このウェブサイト上の情報は「現状のまま」提供され、いかなる種類の保証もありません。サイトまたはそのコンテンツの利用から生じるいかなる損害についても、私は責任を負いません。",
    termsChangesTitle: "規約の変更",
    termsChangesContent: "私はいつでもこれらの利用規約を変更する権利を留保します。変更後もウェブサイトの利用を継続することは、新しい規約への同意を意味します。",
    termsContactTitle: "お問い合わせ",
    termsContactContent: "これらの利用規約に関するご質問がある場合は、以下までご連絡ください。",
    lastUpdated: "最終更新日",
    aboutMeTitle: "自己紹介",
    heyFaizi: "こんにちは、Faiziです",
    aboutMeContent: "私はデータ主導のデジタルマーケターであり、OTA、Eコマース、銀行、B2B SaaS、オフィススペース、物流、多くの中小企業など、さまざまな業種のデジタルキャンペーンを担当した経験があります。",
    experienceTitle: "職務経歴",
    seeSkillset: "スキルセットを見る",
    seeResume: "履歴書を見る",
    psychometricTitle: "適性検査",
    growthMarketer: "グロースマーケター",
    chatPrompt: "お話ししましょう",
    assessmentOverview: "アセスメント概要",
    thinking: "思考",
    connecting: "対人",
    executing: "実行",
    progressing: "進展",
    roleFit: "役割の適合性",
    organisationFit: "組織の適合性",
    aboutSnapsych: "Snapsychアセスメントについて",
    analysing: "分析",
    exploring: "探求",
    networking: "ネットワーキング",
    collaborating: "協力",
    quality: "品質",
    resultsDriven: "結果重視",
    leadership: "リーダーシップ",
    resilience: "レジリエンス",
    adaptability: "適応性",
    thinkingContent1: "Faiziは、問題を理解して解決するために数値データを扱うことに慣れています。Faiziは事実に基づいた傾向があり、仮説を裏付けるために証拠を使用します。",
    thinkingContent2: "Faiziは好奇心が強く、新しいアイデアやアプローチを探求することを好みます。問題に直面したとき、Faiziは枠にとらわれない考え方をする傾向があり、幅広い選択肢を検討することを楽しみます。Faiziは、斬新さと多様性を提供する役割で学び、成長する機会を求めています。反面、Faiziはルーチンワークに飽きやすく、時には楽観的すぎたり非現実的なアイデアを持っていると見なされることがあります。",
    connectingContent1: "Faiziは、新しい人々とつながることに安心感を感じ、一般的に十分に発達したネットワークを持っている人物です。",
    connectingContent2: "Faiziは自分の意見を自分の中に留めておく傾向があり、同僚の問題に関与することを避けます。Faiziはかなり競争心が強く、証明されない限り人々に対して懐疑的かもしれません。Faiziは他人の視点を考慮せずに決定を下すことがあります。",
    executingContent1: "Faiziは体系的、計画的、組織的である傾向があり、期限内に納品します。Faiziは信頼でき、規律正しく、目標達成に向けて邁進します。",
    executingContent2: "Faiziは細部に注意を払い、高い水準の仕事を届けることを楽しみます。",
    progressingContent1: "Faiziは挫折から素早く立ち直り、否定的な感情に引きずられることはありません。Faiziは失敗を学習の機会であり、成功への道の不可欠な一部であると考えています。",
    progressingContent2: "Faiziは集中力があり、障害に関係なくチームを望ましい結果へと導きます。",
    progressingContent3: "Faiziは安定した環境で働くことを好み、計画外の変化に対応することには不慣れです。",
    roleFit1: "パフォーマンスを容易に測定できる、明確な目標やタイムラインがある役割。",
    roleFit2: "研究、分析、データ分析、または問題を解決するために合理的思考を適用することに関連する役割。",
    roleFit3: "新しい慣行の実施、紛願管理を扱う役割。",
    orgFit1: "ペースが速く、結果重視で、パフォーマンスに連動した明確なキャリアパスを提供する組織。",
    orgFit2: "証拠に基づいた批判的思考を促進する組織。",
    snapsychContent1: "Snapsychは、世界中の企業で使用されているビッグファイブおよび関連するフレームワークに基づいています。広く使用されている2つのビッグファイブ性格テストと比較して測定され、良好な相関関係（Saucierのミニマーカーとビッグファイブインベントリ）が示されています。",
    snapsychContent2: "テストの精度（信頼性）平均アルファは.88であり、業界ベンチマーク（>.70）と比較して非常に良好であると見なされます。",
    snapsychContent3: "妥当性 テストは、現代の職業環境に基づいた質問により、良好な面的妥当性を提供します。テストはまた、良好な構成概念妥当性を持ち、ビッグファイブの構造およびビッグファイブ因子とSnapsychの間の相関関係は、閾値p <.05およびp <.01で統計的にテストされています。",
    workMagicRole: "グロースマーケティング＆プロダクトリード",
    tiktokRole: "グロースマーケティングマネージャー",
    greenhouseRole: "グロースマーケター",
    present: "現在",
    skillsetTitle: "スキルセット",
    growthStrategy: "成長と戦略",
    marketingChannels: "マーケティングチャネル",
    productAnalytics: "製品と分析",
    toolsTech: "ツールとテクノロジー",
    growthHacking: "グロースハック",
    cro: "コンバージョン率最適化 (CRO)",
    abTesting: "A/Bテストと実験",
    userAcquisition: "ユーザー獲得戦略",
    performanceMarketing: "運用型広告 (TikTok, Meta, Google)",
    seo: "検索エンジン最適化 (SEO)",
    socialMedia: "ソーシャルメディアマーケティング",
    aso: "アプリストア最適化 (ASO)",
    productManagement: "プロダクトマネジメント",
    dataAnalytics: "データ分析 (SQL, Python)",
    martech: "マーケティングテクノロジー (MarTech)",
    businessIntelligence: "ビジネスインテリジェンス",
    jun2023: "2023年6月",
    apr2021: "2021年4月",
    jun2019: "2019年6月",
    achiever: "アチーバー",
    analytical: "分析的",
    tenacious: "粘り強い",
    resumeSubtitle: "私のプロフェッショナルな旅と学歴のタイムライン。",
    workExperience: "職務経験",
    education: "学歴",
    locationKL: "クアラルンプール、マレーシア",
    workMagicDesc: "<strong>グロースマーケティングリードとして</strong>、マルチチャネルキャンペーンの展開、オンボーディングファネルの最適化、コホートおよびプロダクトデータを用いたパーソナライズされたマーケティングを通じて、ユーザー獲得、リテンション、収益化の推進に注力しました。これにより、キャンペーン全体でトライアルコンバージョン、LTV、ROIが大幅に向上しました。<br/><br/><strong>プロダクトオペレーションリードとして</strong>、エンジニアリングおよびデータチームと横断的に連携し、デリバリーの効率化、AIモデルのパフォーマンス向上、QA、プロンプトエンジニアリング、内部ドキュメントに関するスケーラブルなプロセスの構築に取り組みました。これらの取り組みにより、プロダクトの開発速度、品質、チームのオンボーディングスピードが直接的に改善されました。",
    tiktokDesc: "<strong>グロースカントリーマネージャー (APAC):</strong><ul class='list-disc ml-5 mt-2 mb-4 space-y-1'><li>全対象国のROIターゲット達成を確実にする。</li><li>地域内のクロスファンクショナルチームとのコミュニケーション。</li></ul><strong>運用型広告エージェンシーマネージャー (APAC, EMEA & NA):</strong><ul class='list-disc ml-5 mt-2 mb-4 space-y-1'><li>東南アジア、欧州・中東・アフリカ、北米のエージェンシーとのコミュニケーション管理。</li><li>各国の支出とパフォーマンスを監視し、ROIターゲットの達成を確実にする。</li><li>キャンペーンパフォーマンスを分析し、エージェンシーに技術的な推奨事項を提案する。</li><li>エージェンシーのタスクを管理し、計画通りに実行されるようにする。</li></ul><strong>SEOプロジェクトマネージャー (グローバル):</strong><ul class='list-disc ml-5 mt-2 space-y-1'><li>TT4B公式サイトのSEOロードマップと計画の策定。</li><li>技術改善のためのサイト監査の実施。</li><li>技術チームが実装するためのPRD（製品要求仕様書）の作成。</li><li>コンテンツチームとのオンページ最適化への取り組み。</li></ul>",
    greenhouseDesc: "<strong>運用型広告スペシャリスト:</strong><ul class='list-disc ml-5 mt-2 mb-4 space-y-1'><li>堅牢なデータ主導のデジタルマーケティング戦略を策定する。</li><li>既存のデジタルマーケティングチャネルをマッピング・分析し、改善戦略を作成する。</li><li>デジタルマーケティングキャンペーンを最適化し、目標売上とROIを達成することでビジネスを促進する。</li><li>運用型広告から適格なリードを提供することでセールスチームをサポートする。</li></ul><strong>トラッキング＆データ統合マネージャー:</strong><ul class='list-disc ml-5 mt-2 mb-4 space-y-1'><li>すべてのデジタルマーケティングファネルに対して、世界クラスのデータトラッキングおよびタギング戦略を策定・実施する。</li><li>プラットフォーム間のデータ統合をリードする。</li><li>CRMでワークフローを構築することにより、データストリームラインを自動化する。</li><li>継続的なレポートおよび分析活動に必要なアナリティクストラッキングを実装する。</li><li>継続的なレポートおよび分析活動に必要なアナリティクストラッキングを実装する。</li></ul><strong>データレポート＆可視化:</strong><ul class='list-disc ml-5 mt-2 mb-4 space-y-1'><li>包括的なデジタルマーケティングレポートを作成する。</li><li>すべてのビジネス関連指標を追跡するための運用指標（Ops metric）を開発する。</li><li>統合データソースを使用して、マーケティング部門全体のデータレポートを統一する。</li></ul><strong>SEOマネージャー:</strong><ul class='list-disc ml-5 mt-2 mb-4 space-y-1'><li>効果的なSEO計画と戦略を策定・実施する。</li><li>コンテンツチームを導くためのキーワード調査を実施する。</li><li>テクニカルSEOの問題を確認し、修正を推奨する。</li><li>SEOの観点に従ってウェブサイトのコンテンツやランディングページを最適化する。</li><li>会社全体でリンクビルディングの取り組みを推進する。</li></ul><strong>QAプロダクトテスター:</strong><ul class='list-disc ml-5 mt-2 space-y-1'><li>テストケース（手動または自動）を実行し、結果を分析する。</li><li>バグやエラーを開発チームに報告する。</li></ul>",
    degreeTitle: "工学士（都市計画）",
    uniName: "バンドン工科大学",
    degreeDesc: "都市空間分析、地域インフラ計画、および持続可能な都市開発を専門としていました。インドネシアと日本の防災レジリエンスの比較研究に関する包括的な卒業論文を完成させました。",
    graduated2016: "2009年9月 - 2015年3月",
    selectedWorks: "厳選された作品",
    portfolioSubtitle: "プロダクトデザイン、グロース戦略、技術実装にわたるプロジェクトのコレクション。各作品は、データとデザインを通じて解決されたユニークな課題を表しています。",
    basedIn: "拠点",
    viewCaseStudy: "ケーススタディを見る",
    haveProject: "プロジェクトをお考えですか？",
    projectDesc: "新しいプロジェクト、クリエイティブなアイデア、またはあなたのビジョンの一部になる機会について、いつでもお話しさせていただきます。",
    letsTalk: "話しましょう",
    blogSubtitle: "デザイン、テクノロジー、人間行動の交差点を探索。デジタル製品の構築とスケーリングに関する毎週の洞察。",
    stayInLoop: "最新情報を入手。",
    newsletterDesc: "ニュースレターを購読して、最新の記事、リソース、洞察を直接受信トレイに受け取ります。",
    subscribe: "購読する",
    emailPlaceholder: "あなたのメールアドレス",
    readMore: "続きを読む",
    letsConnect: "つながりましょう",
    contactSubtitle: "プロジェクトをお考えですか、それとも成長、製品、テクノロジーについてチャットしたいですか？新しい機会や会話をいつでも歓迎します。",
    contactDescription: "私はいつでもプロジェクトでの協力や機会についてお話しすることを歓迎します！",
    wantToCallMe: "電話をご希望ですか？",
    scheduleCall: "私との通話を予約する",
    wantToEmailMe: "メールをご希望ですか？",
    emailMe: "メールを送る",
    socialHandle: "ソーシャルハンドル",
    location: "場所",
    followMe: "フォローする",
    fullName: "フルネーム",
    email: "メール",
    subject: "件名",
    subjectPlaceholder: "何かお手伝いできることはありますか？",
    message: "メッセージ",
    emailAddress: "メールアドレス",
    yourMessage: "メッセージ",
    messagePlaceholder: "プロジェクトについて教えてください...",
    sendMessage: "メッセージを送信",
    sending: "送信中...",
    messageSent: "送信完了！",
    messageSuccess: "お問い合わせいただきありがとうございます。できるだけ早くご連絡いたします。",
    messageError: "エラーが発生しました。もう一度お試しいただくか、直接メールでお問い合わせください。",
    sendAnother: "別のメッセージを送信",
    captchaRequired: "キャプチャを完了してください。",
    theChallenge: "課題",
    solutions: "解決策",
    keyResults: "主な結果",
    aboutClient: "について",
    readyToAchieve: "同様の結果を達成する準備はできていますか？",
    backToPortfolio: "ポートフォリオに戻る",
    projectNotFound: "プロジェクトが見つかりません",
    scrollZoomHint: "スクロールでズーム • ドラッグでパン • モバイルでピンチ",
    client: "クライアント",
    categoryLabel: "カテゴリー",
    licensesAndCertifications: "ライセンスと資格",
    skills: "スキル",
    irepRole: "Digital Marketing Strategist & Media Planner",
    irepDesc: "<strong>デジタルマーケティングストラテジスト:</strong><ul class='list-disc ml-5 mt-2 mb-4 space-y-1'><li>キーワードプランニングを実施し、潜在的なユーザー獲得にリーチするためのキーワード掛け合わせを生成する。</li><li>クライアントのKPIを達成するために、リスティング広告キャンペーンを管理・実行する。</li><li>進行中のキャンペーンの予算進捗を監視・追跡する。</li><li>キャンペーンパフォーマンスを最適化するための分析を行う。</li><li>A/BテストやLPテストを実施し、広告コピーやランディングページを最適化する。</li><li>キャンペーンレポートとプレゼンテーションの作成。</li></ul><strong>デジタルメディアプランナー:</strong><ul class='list-disc ml-5 mt-2 space-y-1'><li>潜在的なクライアントとの会議を設定し、デジタルマーケティングの提案書を提出することで、クライアントの戦略的マーケティング計画に助言やアイデアを提供する。</li><li>クライアントのビジネス目標に基づいて、各デジタルマーケティングチャネルの提案を行う。</li><li>デジタルメディアプランを作成・提示し、プロジェクトスケジュール、予算計画、品質管理などの計画を実行する。</li><li>広告キャンペーンの結果を要約し、洞察に満ちたレポートにまとめる。</li><li>広告キャンペーンの結果を分析し、クライアントのビジネスを前進させるための次のアクションとして提案および改善策を提示する。</li><li>クライアントと定期的に会議を行い、キャンペーンの進捗状況と改善提案を報告する。</li></ul>",
    locationTokyo: "東京都、日本",
    locationBandung: "バンドン、インドネシア",
    locationJakarta: "ジャカルタ、インドネシア",
    locationUSRemote: "アメリカ合衆国 (リモート)",
    locationSGRemote: "シンガポール (リモート)",
    oct2018: "2018年10月",
    may2019: "2019年5月",
    sep2016: "2016年9月",
    mar2018: "2018年3月",
    aug2018: "2018年8月",
    jan2016: "2016年1月",
    may2020: "2020年5月",
    may2021: "2021年5月",
    jun2022: "2022年6月",
    dec2017: "2017年12月",
    dec2018: "2018年12月",
    feb2019: "2019年2月",
    feb2020: "2020年2月",
    mar2019: "2019年3月",
    mar2020: "2020年3月",
    license1Title: "Google 検索広告認定資格",
    license1Issuer: "Google",
    license2Title: "インバウンドマーケティング認定資格",
    license2Issuer: "HubSpot",
    license3Title: "日本語能力試験 N3",
    license3Issuer: "国際交流基金",
    license4Title: "Hubspot マーケティングソフトウェア認定資格",
    license4Issuer: "Hubspot",
    license5Title: "Google ショッピング広告認定資格",
    license5Issuer: "Google",
    license6Title: "Google 動画広告認定資格",
    license6Issuer: "Google",
    license7Title: "Google アナリティクス個人認定資格",
    license7Issuer: "Google",
    credentialId: "資格 ID",
    expires: "有効期限",
    skillCategory1: "成長と戦略",
    skillCategory2: "マーケティングチャネル",
    skillCategory3: "製品と分析",
    skillCategory4: "ツールとテクノロジー",
    portfolioProject1Title: "アッパーファネルキャンペーンによるROI向上を確認するためのコンバージョンリフト調査",
    portfolioProject1Desc: "包括的なコンバージョンリフト調査を通じて、アッパーファネルキャンペーンが全体的なROIに与える影響を分析しました。",
    portfolioProject2Title: "CoHiveがコンバージョン率最適化戦略を使用してCPAを62％削減した方法",
    portfolioProject2Desc: "獲得コストを大幅に削減し、ユーザージャーニーの効率を向上させるための戦略的なCROフレームワークを実装しました。",
    portfolioProject3Title: "DJTが6か月で平均月間オーガニックトラフィックを40倍に増やした方法",
    portfolioProject3Desc: "テクニカルSEO監査とコンテンツ戦略の最適化を通じて、爆発的なオーガニック成長を推進しました。",
    portfolioProject4Title: "Lemoniloがショッピング広告を使用してROASを8倍に増やした方法",
    portfolioProject4Desc: "健康志向の大手Eコマースブランド向けに、広告費用対効果を最大化するためにショッピング広告キャンペーンを最適化しました。",
    nov2017: "2017年11月",
    techStack: "技術スタック",
    pageNotFound: "ページが見つかりません",
    backToHome: "ホームに戻る",
    oops: "おっと！お探しのページは存在しません。",
    pricing: "料金プラン",
    pricingTitle: "グロースマーケティング＆広告運用 料金プラン",
    pricingSubtitle: "広告費と成長フェーズに応じた、透明性が高く成果重視のリテーナープランを提供します。",
    category: "カテゴリー",
    items: "項目",
    adSpendLimits: "広告費上限",
    adSpendingRange: "月間広告費レンジ",
    monthlyFee: "月額基本料金",
    threeMonthCommitment: "3ヶ月契約",
    sixMonthCommitment: "6ヶ月契約",
    annualCommitment: "年間契約",
    monthlyCommitment: "月額（単月）",
    noCommitment: "確約なし",
    noDiscount: "割引なし",
    monthlyAdSpend: "月間広告費",
    calculatePlan: "プランと費用のシミュレーション",
    sliderHint: "スライダーを動かすか直接数値を入力すると、該当プランと概算運用手数料が自動計算されます。",
    estimatedManagementFee: "概算運用手数料",
    selectedPlan: "該当プラン",
    yourMonthlySpend: "月間広告予算",
    retainerLimits: "稼働時間上限",
    consultant: "コンサルタント",
    adOpsSpecialists: "広告運用スペシャリスト",
    serviceDetails: "サービス詳細",
    meetingCadence: "定例ミーティング頻度",
    reportingPlatform: "レポートプラットフォーム",
    adChannels: "対応広告媒体数",
    upgrades: "アップグレードオプション",
    crmIntegration: "CRM連携",
    creativesProduction: "クリエイティブ制作",
    pricingNote: "※注記: すべてのプランには、プロジェクト設計、キャンペーン計画、広告初期設定、運用最適化、トラッキング設定、およびレポーティングが標準で含まれています。",
    choosePlan: "プランを選択",
    customQuote: "個別見積もり",
    flat: "固定",
    discount: "割引",
    standard: "Standard",
    standardTier: "Standard",
    growthTier: "Growth",
    scaleTier: "Scale",
    premiumTier: "Premium",
    enterpriseTier: "Enterprise",
  },
  ID: {
    about: "Tentang",
    home: "Beranda",
    resume: "Resume",
    portfolio: "Portofolio",
    blog: "Blog",
    psychometric: "Psikometrik",
    getInTouch: "Hubungi Saya",
    introTitle: "Halo, Saya Faizi!",
    introSub: "Growth Marketing & Product Lead di WorkMagic",
    learnMore: "Pelajari lebih lanjut tentang saya",
    myResume: "Resume saya",
    tiktok: "TikTok",
    tiktokTitle: "Studi Peningkatan Konversi",
    workTogether: "Mari bekerja sama ✨",
    getInTouchNow: "Hubungi sekarang",
    growth: "Pertumbuhan",
    pokemonTitle: "Di Balik Strategi Monetisasi Pokémon",
    privacy: "Kebijakan Privasi",
    terms: "Syarat & Ketentuan",
    privacyIntroTitle: "Pendahuluan",
    privacyIntroContent: "Privasi Anda penting bagi saya. Kebijakan Privasi ini menjelaskan bagaimana saya mengumpulkan, menggunakan, dan melindungi informasi Anda saat Anda mengunjungi situs web saya.",
    privacyCollectionTitle: "Pengumpulan Informasi",
    privacyCollectionContent: "Saya tidak mengumpulkan informasi identitas pribadi (PII) apa pun kecuali Anda memberikannya secara sukarela melalui formulir kontak atau langganan buletin. Ini mungkin termasuk nama dan alamat email Anda.",
    privacyUseTitle: "Penggunaan Informasi",
    privacyUseContent: "Setiap informasi yang diberikan digunakan semata-mata untuk menanggapi pertanyaan Anda atau mengirimi Anda pembaruan yang diminta. Saya tidak menjual atau membagikan informasi Anda dengan pihak ketiga untuk tujuan pemasaran.",
    privacyCookiesTitle: "Cookie",
    privacyCookiesContent: "Situs web ini mungkin menggunakan cookie dasar untuk meningkatkan pengalaman browsing Anda dan menganalisis lalu lintas situs. Anda dapat memilih untuk menonaktifkan cookie melalui pengaturan browser Anda.",
    privacyContactTitle: "Kontak",
    privacyContactContent: "Jika Anda memiliki pertanyaan mengenai Kebijakan Privasi ini, silakan hubungi saya di:",
    termsAgreementTitle: "Persetujuan terhadap Ketentuan",
    termsAgreementContent: "Dengan mengakses dan menggunakan situs web ini, Anda setuju untuk terikat oleh Syarat dan Ketentuan ini. Jika Anda tidak setuju, mohon jangan gunakan situs ini.",
    termsIPTitle: "Hak Kekayaan Intelektual",
    termsIPContent: "Semua konten di situs web ini, termasuk teks, gambar, and kode, adalah milik Faizi Zahari kecuali dinyatakan lain. Anda tidak boleh mereproduksi atau mendistribusikan konten apa pun tanpa izin tertulis sebelumnya.",
    termsUseTitle: "Penggunaan Situs Web",
    termsUseContent: "Anda setuju untuk menggunakan situs web ini hanya untuk tujuan yang sah. Anda dilarang mencoba mendapatkan akses tidak sah ke bagian mana pun dari situs atau sistemnya.",
    termsDisclaimersTitle: "Penafian",
    termsDisclaimersContent: "Informasi di situs web ini disediakan \"apa adanya\" tanpa jaminan apa pun. Saya tidak bertanggung jawab atas kerusakan apa pun yang timbul dari penggunaan situs atau kontennya.",
    termsChangesTitle: "Perubahan Ketentuan",
    termsChangesContent: "Saya berhak mengubah Syarat dan Ketentuan ini kapan saja. Penggunaan berkelanjutan Anda atas situs web setelah perubahan apa pun menunjukkan penerimaan Anda terhadap ketentuan baru.",
    termsContactTitle: "Kontak",
    termsContactContent: "Jika Anda memiliki pertanyaan mengenai Syarat dan Ketentuan ini, silakan hubungi saya di:",
    lastUpdated: "Terakhir diperbarui",
    aboutMeTitle: "Tentang Saya",
    heyFaizi: "Halo, Saya Faizi",
    aboutMeContent: "Saya adalah pemasar digital berbasis data dengan pengalaman menangani kampanye digital dari berbagai vertikal seperti OTA, E-commerce, Perbankan, B2B SaaS, Ruang Kantor, Logistik, dan banyak UKM.",
    experienceTitle: "Pengalaman",
    seeSkillset: "Lihat keahlian saya",
    seeResume: "Lihat resume saya",
    psychometricTitle: "Psikometrik",
    growthMarketer: "Growth Marketer",
    chatPrompt: "Mari mengobrol",
    assessmentOverview: "Ikhtisar penilaian",
    thinking: "Berpikir",
    connecting: "Menghubungkan",
    executing: "Mengeksekusi",
    progressing: "Berkembang",
    roleFit: "Kesesuaian Peran",
    organisationFit: "Kesesuaian Organisasi",
    aboutSnapsych: "Tentang Penilaian Snapsych",
    analysing: "Menganalisis",
    exploring: "Menjelajah",
    networking: "Jejaring",
    collaborating: "Berkolaborasi",
    quality: "Kualitas",
    resultsDriven: "Berorientasi Hasil",
    leadership: "Kepemimpinan",
    resilience: "Ketahanan",
    adaptability: "Adaptabilitas",
    thinkingContent1: "Faizi merasa nyaman dalam menangani data numerik untuk memahami masalah dan menyelesaikannya. Faizi cenderung faktual dan menggunakan bukti untuk mendukung hipotesis mereka.",
    thinkingContent2: "Faizi memiliki rasa ingin tahu yang tinggi dan suka mengeksplorasi ide serta pendekatan baru. Saat menghadapi masalah, Faizi cenderung berpikir di luar kebiasaan dan menikmati mempertimbangkan berbagai alternatif. Faizi mencari peluang untuk belajar dan berkembang dalam peran yang menawarkan kebaruan dan variasi. Di sisi lain, Faizi mungkin merasa bosan dalam rutinitas dan terkadang dianggap terlalu optimis atau memiliki ide yang tidak praktis.",
    connectingContent1: "Faizi adalah seseorang yang merasa nyaman saat terhubung dengan orang baru dan umumnya memiliki jaringan yang berkembang dengan baik.",
    connectingContent2: "Faizi cenderung menyimpan pendapat untuk diri sendiri dan menghindari terlibat dalam masalah rekan kerja. Faizi bisa sangat kompetitif dan mungkin skeptis terhadap orang lain kecuali terbukti sebaliknya. Faizi mungkin mengambil keputusan tanpa mempertimbangkan sudut pandang orang lain.",
    executingContent1: "Faizi cenderung sistematis, metodis, dan terorganisir serta memberikan hasil dalam tenggat waktu. Faizi dapat diandalkan dan disiplin serta terdorong untuk mencapai tujuan mereka.",
    executingContent2: "Faizi memperhatikan detail dan menikmati memberikan pekerjaan dengan standar tinggi.",
    progressingContent1: "Faizi pulih dengan cepat dari kegagalan dan tidak membiarkan negativitas menjatuhkan mereka. Faizi memandang kegagalan sebagai peluang belajar dan bagian intrinsik dari jalan menuju kesuksesan.",
    progressingContent2: "Faizi fokus dan mendorong tim mereka menuju hasil yang diinginkan terlepas dari hambatan.",
    progressingContent3: "Faizi lebih suka bekerja di lingkungan yang stabil dan merasa tidak nyaman dalam menangani perubahan yang tidak terencana.",
    roleFit1: "Peran dengan tujuan atau lini masa yang jelas, di mana kinerja dapat diukur dengan mudah.",
    roleFit2: "Peran yang berkaitan dengan penelitian, analisis, analitik data, atau penerapan pemikiran rasional untuk memecahkan masalah.",
    roleFit3: "Peran yang berhubungan dengan penerapan praktik baru, manajemen konflik.",
    orgFit1: "Organisasi yang bergerak cepat, berorientasi hasil, dan menawarkan jalur karier yang jelas yang terkait dengan kinerja Anda.",
    orgFit2: "Organisasi yang mempromosikan pemikiran kritis berbasis bukti.",
    snapsychContent1: "Snapsych didasarkan pada Big Five dan kerangka kerja terkait yang digunakan oleh perusahaan secara global. Ini telah diukur terhadap dua tes kepribadian Big Five yang banyak digunakan dan menunjukkan korelasi yang baik (mini-marker Saucier dan Big Five Inventory).",
    snapsychContent2: "Akurasi (reliabilitas) tes Rata-rata alpha adalah .88, yang dianggap sangat baik dibandingkan dengan tolok ukur industri (> .70).",
    snapsychContent3: "Validitas Tes ini memberikan validitas wajah yang baik dengan pertanyaan berdasarkan pengaturan pekerjaan modern. Tes ini juga memiliki Validitas Konstruk yang baik dan struktur Big Five serta korelasi antara faktor Big Five dan Snapsych telah diuji secara statistik pada ambang batas p <.05 dan p <.01.",
    workMagicRole: "Growth Marketing & Product Lead",
    tiktokRole: "Growth Marketing Manager",
    greenhouseRole: "Growth Marketer",
    present: "Sekarang",
    skillsetTitle: "Keahlian",
    growthStrategy: "Pertumbuhan & Strategi",
    marketingChannels: "Saluran Pemasaran",
    productAnalytics: "Produk & Analitik",
    toolsTech: "Alat & Teknologi",
    growthHacking: "Growth Hacking",
    cro: "Optimasi Tingkat Konversi (CRO)",
    abTesting: "A/B Testing & Eksperimentasi",
    userAcquisition: "Strategi Akuisisi Pengguna",
    performanceMarketing: "Performance Marketing (TikTok, Meta, Google)",
    seo: "Optimasi Mesin Pencari (SEO)",
    socialMedia: "Pemasaran Media Sosial",
    aso: "Optimasi App Store (ASO)",
    productManagement: "Manajemen Produk",
    dataAnalytics: "Analitik Data (SQL, Python)",
    martech: "Teknologi Pemasaran (MarTech)",
    businessIntelligence: "Kecerdasan Bisnis",
    jun2023: "Jun 2023",
    apr2021: "Apr 2021",
    jun2019: "Jun 2019",
    achiever: "Pencapai",
    analytical: "Analitis",
    tenacious: "Gigih",
    resumeSubtitle: "Garis waktu perjalanan profesional dan latar belakang akademik saya.",
    workExperience: "Pengalaman Kerja",
    education: "Pendidikan",
    locationKL: "Kuala Lumpur, Malaysia",
    workMagicDesc: "<strong>Sebagai Growth Marketing Lead</strong>, saya fokus pada mendorong akuisisi pengguna, retensi, dan monetisasi dengan meluncurkan kampanye multi-saluran, mengoptimalkan corong orientasi (onboarding funnels), dan mempersonalisasi pemasaran menggunakan data kohort dan produk. Hal ini menghasilkan peningkatan signifikan dalam konversi uji coba, LTV, dan ROI di seluruh kampanye.<br/><br/><strong>Sebagai Product Operations Lead</strong>, saya bekerja secara lintas fungsi dengan tim teknik dan data untuk merampingkan pengiriman, meningkatkan kinerja model AI, dan membangun proses yang skalabel seputar QA, prompt engineering, dan dokumentasi internal. Upaya-upaya ini secara langsung meningkatkan kecepatan produk, kualitas, dan kecepatan orientasi tim.",
    tiktokDesc: "<strong>Growth Country Manager (APAC):</strong><ul class='list-disc ml-5 mt-2 mb-4 space-y-1'><li>Memastikan semua negara mencapai target ROI.</li><li>Berkomunikasi dengan tim lintas fungsi di wilayah tersebut.</li></ul><strong>Paid Ads Agency Manager (APAC, EMEA & NA):</strong><ul class='list-disc ml-5 mt-2 mb-4 space-y-1'><li>Mengelola komunikasi Agensi di SEA, EMEA, dan NA.</li><li>Memantau Pengeluaran dan Performa untuk setiap negara guna memastikan pencapaian target ROI.</li><li>Menganalisis performa kampanye dan memberikan rekomendasi teknis kepada agensi.</li><li>Mengelola tugas-tugas agensi dan memastikan eksekusi sesuai rencana.</li></ul><strong>SEO Project Manager (Global):</strong><ul class='list-disc ml-5 mt-2 space-y-1'><li>Membuat Roadmap dan Rencana SEO untuk Situs Web Resmi TT4B.</li><li>Melakukan Audit Situs untuk peningkatan teknis.</li><li>Membuat PRD untuk tim teknis guna implementasi.</li><li>Bekerja pada optimasi On-page bersama tim konten.</li></ul>",
    greenhouseDesc: "<strong>Paid Ads Specialist:</strong><ul class='list-disc ml-5 mt-2 mb-4 space-y-1'><li>Mengembangkan strategi pemasaran digital berbasis data yang kuat.</li><li>Memetakan dan menganalisis saluran pemasaran digital yang ada serta membuat strategi peningkatan.</li><li>Mendorong bisnis dengan mengoptimalkan kampanye pemasaran digital untuk mencapai target Pendapatan & ROI.</li><li>Mendukung tim penjualan dengan menyediakan prospek (leads) berkualitas dari iklan berbayar.</li></ul><strong>Tracking & Data Integration Manager:</strong><ul class='list-disc ml-5 mt-2 mb-4 space-y-1'><li>Mengembangkan dan mengimplementasikan strategi pelacakan & penandaan data kelas dunia untuk semua corong pemasaran digital.</li><li>Memimpin integrasi data antar platform kami.</li><li>Mengotomatiskan aliran data dengan membangun alur kerja di CRM.</li><li>Mengimplementasikan pelacakan analitik yang diperlukan untuk aktivitas pelaporan dan analisis berkelanjutan.</li></ul><strong>Data Reporting & Visualization:</strong><ul class='list-disc ml-5 mt-2 mb-4 space-y-1'><li>Membangun laporan pemasaran digital yang komprehensif.</li><li>Mengembangkan metrik operasional untuk melacak semua metrik terkait bisnis.</li><li>Menyatukan Pelaporan Data di seluruh Departemen Pemasaran menggunakan sumber data yang terintegrasi.</li></ul><strong>SEO Manager:</strong><ul class='list-disc ml-5 mt-2 mb-4 space-y-1'><li>Mengembangkan dan mengimplementasikan Rencana & Strategi SEO yang efektif.</li><li>Melakukan riset kata kunci untuk memandu tim konten.</li><li>Meninjau masalah SEO teknis dan merekomendasikan perbaikan.</li><li>Mengoptimalkan konten situs web dan halaman landas agar mengikuti aspek SEO.</li><li>Mendorong seluruh perusahaan untuk melakukan upaya pembangunan tautan (link-building).</li></ul><strong>QA Product Tester:</strong><ul class='list-disc ml-5 mt-2 space-y-1'><li>Mengeksekusi kasus uji (manual atau otomatis) dan menganalisis hasil.</li><li>Melaporkan bug dan kesalahan kepada tim pengembang.</li></ul>",
    degreeTitle: "Sarjana Teknik, Perencanaan Wilayah dan Kota",
    uniName: "Institut Teknologi Bandung",
    degreeDesc: "Spesialisasi dalam analisis spasial perkotaan, perencanaan infrastruktur wilayah, dan pengembangan kota berkelanjutan. Menyelesaikan skripsi komprehensif tentang studi komparatif ketahanan bencana antara Indonesia dan Jepang.",
    graduated2016: "Sep 2009 - Mar 2015",
    selectedWorks: "Karya Terpilih",
    portfolioSubtitle: "Koleksi proyek yang mencakup desain produk, strategi pertumbuhan, dan implementasi teknis. Setiap karya mewakili tantangan unik yang diselesaikan melalui data dan desain.",
    basedIn: "Berbasis di",
    viewCaseStudy: "Lihat Studi Kasus",
    haveProject: "Punya proyek dalam pikiran?",
    projectDesc: "Saya selalu terbuka untuk mendiskusikan proyek baru, ide kreatif, atau peluang untuk menjadi bagian dari visi Anda.",
    letsTalk: "Mari Berbicara",
    blogSubtitle: "Menjelajahi persimpangan antara desain, teknologi, dan perilaku manusia. Wawasan mingguan tentang membangun dan menskalakan produk digital.",
    stayInLoop: "Tetap terhubung.",
    newsletterDesc: "Berlangganan buletin saya untuk menerima artikel, sumber daya, dan wawasan terbaru langsung di kotak masuk Anda.",
    subscribe: "Berlangganan",
    emailPlaceholder: "Alamat email Anda",
    readMore: "Baca Selengkapnya",
    letsConnect: "Mari Terhubung",
    contactSubtitle: "Punya proyek dalam pikiran atau hanya ingin mengobrol tentang pertumbuhan, produk, atau teknologi? Saya selalu terbuka untuk peluang dan percakapan baru.",
    contactDescription: "Saya selalu terbuka untuk berkolaborasi dalam sebuah proyek atau mendengar tentang sebuah peluang!",
    wantToCallMe: "INGIN MENGHUBUNGI SAYA?",
    scheduleCall: "Jadwalkan panggilan dengan saya",
    wantToEmailMe: "HANYA INGIN MENGIRIM EMAIL?",
    emailMe: "Email Saya",
    socialHandle: "Handle Sosial",
    location: "Lokasi",
    followMe: "Ikuti Saya",
    fullName: "Nama Lengkap",
    email: "Email",
    subject: "Subjek",
    subjectPlaceholder: "Apa yang bisa saya bantu?",
    message: "Pesan",
    emailAddress: "Alamat Email",
    yourMessage: "Pesan Anda",
    messagePlaceholder: "Ceritakan tentang proyek Anda...",
    sendMessage: "Kirim Pesan",
    sending: "Mengirim...",
    messageSent: "Pesan Terkirim!",
    messageSuccess: "Terima kasih telah menghubungi saya. Saya akan segera membalas pesan Anda.",
    messageError: "Terjadi kesalahan. Silakan coba lagi atau hubungi saya langsung melalui email.",
    sendAnother: "Kirim pesan lain",
    captchaRequired: "Silakan selesaikan captcha.",
    theChallenge: "Tantangan",
    solutions: "Solusi",
    keyResults: "Hasil Utama",
    aboutClient: "Tentang",
    readyToAchieve: "Siap untuk mencapai hasil serupa?",
    backToPortfolio: "Kembali ke Portofolio",
    projectNotFound: "Proyek tidak ditemukan",
    scrollZoomHint: "Gulir untuk zoom • Seret untuk geser • Cubit di ponsel",
    client: "Klien",
    categoryLabel: "Kategori",
    licensesAndCertifications: "Lisensi & Sertifikasi",
    skills: "Keahlian",
    irepRole: "Digital Marketing Strategist & Media Planner",
    irepDesc: "<strong>Digital Marketing Strategist:</strong><ul class='list-disc ml-5 mt-2 mb-4 space-y-1'><li>Melakukan perencanaan kata kunci dan menghasilkan multiplikasi kata kunci untuk mencapai akuisisi pengguna potensial.</li><li>Mengelola & mengeksekusi kampanye iklan pencarian berbayar untuk memenuhi KPI klien.</li><li>Memantau dan melacak kecepatan anggaran untuk kampanye yang sedang berlangsung.</li><li>Melakukan analitik untuk mengoptimalkan performa kampanye.</li><li>Mengoptimalkan salinan iklan dan halaman landas dengan melakukan A/B Testing dan LP Testing.</li><li>Membuat laporan dan presentasi kampanye.</li></ul><strong>Digital Media Planner:</strong><ul class='list-disc ml-5 mt-2 space-y-1'><li>Mengatur pertemuan dengan klien potensial, memberikan saran dan ide kepada klien untuk rencana pemasaran strategis mereka dengan menyerahkan proposal pemasaran digital.</li><li>Memberikan saran untuk setiap saluran pemasaran digital berdasarkan tujuan bisnis klien.</li><li>Membuat perencanaan media digital, mempresentasikan, dan mengeksekusi rencana tersebut seperti jadwal proyek, perencanaan anggaran, dan manajemen kualitas.</li><li>Merangkum hasil kampanye iklan dan mendeskripsikannya ke dalam laporan yang berwawasan.</li><li>Menganalisis hasil kampanye iklan dan memberikan saran serta proposal perbaikan sebagai tindakan selanjutnya untuk mendorong kemajuan bisnis klien.</li><li>Mengadakan pertemuan rutin dengan klien untuk melaporkan kemajuan kampanye dan proposal perbaikan.</li></ul>",
    locationTokyo: "Tokyo, Jepang",
    locationBandung: "Bandung, Indonesia",
    locationJakarta: "Jakarta, Indonesia",
    locationUSRemote: "Amerika Serikat (Remote)",
    locationSGRemote: "Singapura (Remote)",
    oct2018: "Okt 2018",
    may2019: "Mei 2019",
    sep2016: "Sep 2016",
    mar2018: "Mar 2018",
    aug2018: "Agu 2018",
    jan2016: "Jan 2016",
    may2020: "Mei 2020",
    may2021: "Mei 2021",
    jun2022: "Jun 2022",
    dec2017: "Des 2017",
    dec2018: "Des 2018",
    feb2019: "Feb 2019",
    feb2020: "Feb 2020",
    mar2019: "Mar 2019",
    mar2020: "Mar 2020",
    license1Title: "Google Search Ads Certification",
    license1Issuer: "Google",
    license2Title: "Inbound Marketing Certification",
    license2Issuer: "HubSpot",
    license3Title: "Japanese Language Proficiency Test N3",
    license3Issuer: "The Japan Foundation",
    license4Title: "Hubspot Marketing Software Certification",
    license4Issuer: "Hubspot",
    license5Title: "Google Shopping Ads Certification",
    license5Issuer: "Google",
    license6Title: "Google Video Ads Certification",
    license6Issuer: "Google",
    license7Title: "Google Analytics Individual Qualification",
    license7Issuer: "Google",
    credentialId: "ID Kredensial",
    expires: "Kedaluwarsa",
    skillCategory1: "Pertumbuhan & Strategi",
    skillCategory2: "Saluran Pemasaran",
    skillCategory3: "Produk & Analitik",
    skillCategory4: "Alat & Teknologi",
    portfolioProject1Title: "Studi Peningkatan Konversi untuk melihat peningkatan ROI dengan menjalankan Kampanye Upper Funnel",
    portfolioProject1Desc: "Menganalisis dampak kampanye upper funnel terhadap ROI keseluruhan melalui studi peningkatan konversi yang komprehensif.",
    portfolioProject2Title: "Bagaimana CoHive Menurunkan CPA sebesar 62% menggunakan Strategi Optimasi Tingkat Konversi",
    portfolioProject2Desc: "Mengimplementasikan kerangka kerja CRO strategis untuk secara signifikan mengurangi biaya akuisisi dan meningkatkan efisiensi perjalanan pengguna.",
    portfolioProject3Title: "Bagaimana DJT meningkatkan rata-rata lalu lintas organik bulanan sebesar 40x dalam 6 Bulan",
    portfolioProject3Desc: "Mendorong pertumbuhan organik yang eksplosif melalui audit SEO teknis dan optimasi strategi konten.",
    portfolioProject4Title: "Bagaimana Lemonilo meningkatkan ROAS sebesar 8x menggunakan Iklan Belanja",
    portfolioProject4Desc: "Mengoptimalkan kampanye iklan belanja untuk memaksimalkan laba atas belanja iklan bagi merek e-commerce terkemuka yang berfokus pada kesehatan.",
    nov2017: "Nov 2017",
    techStack: "Teknologi",
    pageNotFound: "Halaman Tidak Ditemukan",
    backToHome: "Kembali ke Beranda",
    oops: "Ups! Halaman yang Anda cari tidak ada.",
    pricing: "Paket Harga",
    pricingTitle: "Paket Harga Growth Marketing & Operasional Iklan",
    pricingSubtitle: "Paket retainer transparan dan berorientasi kinerja yang dirancang untuk mengembangkan bisnis Anda dengan strategi pertumbuhan dan operasional iklan menyeluruh.",
    category: "Kategori",
    items: "Item",
    adSpendLimits: "Batas Belanja Iklan",
    adSpendingRange: "Rentang Belanja Iklan",
    monthlyFee: "Biaya Bulanan",
    threeMonthCommitment: "Komitmen 3 Bulan",
    sixMonthCommitment: "Komitmen 6 Bulan",
    annualCommitment: "Komitmen Tahunan",
    monthlyCommitment: "Bulanan",
    noCommitment: "Tanpa Komitmen",
    noDiscount: "Tanpa Diskon",
    monthlyAdSpend: "Pengeluaran Iklan Bulanan",
    calculatePlan: "Hitung Paket & Estimasi Biaya",
    sliderHint: "Geser slider atau masukkan anggaran iklan untuk menghitung estimasi biaya dan melihat paket yang cocok.",
    estimatedManagementFee: "Estimasi Biaya Manajemen",
    selectedPlan: "Paket yang Cocok",
    yourMonthlySpend: "Anggaran Iklan Bulanan",
    retainerLimits: "Batas Retainer",
    consultant: "Konsultan",
    adOpsSpecialists: "Spesialis Ad Ops",
    serviceDetails: "Detail Layanan",
    meetingCadence: "Frekuensi Rapat",
    reportingPlatform: "Platform Pelaporan",
    adChannels: "Saluran Iklan",
    upgrades: "Opsi Tambahan",
    crmIntegration: "Integrasi CRM",
    creativesProduction: "Produksi Kreatif",
    pricingNote: "Catatan: Semua paket sudah mencakup Perencanaan Proyek, Perencanaan Kampanye, Pengaturan Iklan, Optimasi Iklan, Pengaturan Pelacakan, dan Pelaporan.",
    choosePlan: "Pilih Paket",
    customQuote: "Penawaran Khusus",
    flat: "Tetap",
    discount: "Diskon",
    standard: "Standard",
    standardTier: "Standard",
    growthTier: "Growth",
    scaleTier: "Scale",
    premiumTier: "Premium",
    enterpriseTier: "Enterprise",
  }
};
